module.exports = __webpack_public_path__ + "img/GHS_blanc.c814b9f1.svg";